import { CheckCircle2, Clock, Shield, Award, Wrench } from 'lucide-react';
import { motion } from 'motion/react';

const usps = [
  { icon: Clock, text: '24–48h Lead Times' },
  { icon: Wrench, text: 'Custom Sizes' },
  { icon: Shield, text: 'Tempered/Laminated' },
  { icon: CheckCircle2, text: 'Pro Installers' },
  { icon: Award, text: '1-Year Warranty' },
];

export function USPRow() {
  return (
    <section className="py-8 bg-gradient-to-r from-gray-50 to-white border-y border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-6 md:gap-8">
          {usps.map((usp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm border border-border/50 shadow-sm hover:shadow-md transition-shadow"
            >
              <usp.icon className="w-4 h-4 text-primary" />
              <span className="text-sm whitespace-nowrap">{usp.text}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
